// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"9584a164","747":"891f333e"}[chunkId] + ".css";
};